import { IInfoBarProps, TInfoBarColor, TInfoBarVariant } from './types'
import styles from './styles.module.scss'
import { ButtonBase } from '../Button/ButtonBase'
import {
  CheckCircle,
  CheckCircleFilled,
  ExclaimCircle,
  ExclaimCircleFilled,
  ExclaimTriangle,
  ExclaimTriangleFilled,
} from '.'
import { useState } from 'react'
import clsx from 'clsx'

const InfoBar = ({
  color = 'blue',
  hasBorderRadius = true,
  id = 'mui-info-bar',
  onClick = undefined,
  size = 'md',
  style,
  text,
  variant = 'filled',
  cta,
  ...props
}: IInfoBarProps) => {
  const [isVisible, setIsVisible] = useState(true)

  const getIcon = (color: TInfoBarColor, variant: TInfoBarVariant) => {
    switch (color) {
      case 'green':
        return variant === 'filled' ? <CheckCircle /> : <CheckCircleFilled />
      case 'red':
        return variant === 'filled' ? <ExclaimCircle /> : <ExclaimCircleFilled />
      case 'yellow':
        return variant === 'filled' ? <ExclaimTriangle /> : <ExclaimTriangleFilled />
      default:
        return variant === 'filled' ? <ExclaimCircle /> : <ExclaimCircleFilled />
    }
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault()
    onClick && onClick(id)
    setIsVisible(false)
  }

  if (!isVisible) return <></>

  return (
    <div
      aria-label="important information"
      aria-live="polite"
      className={clsx(
        'mui-info-bar',
        styles.infoBar,
        styles[color],
        styles[size],
        styles[variant],
        { [styles.noBorderRadius]: !hasBorderRadius },
      )}
      data-testid="mui-info-bar"
      id={id}
      role="alert"
      style={{ ...style }}
      {...props}
    >
      <div className={styles.inner}>
        <span data-style="icon" className={styles.icon}>
          {getIcon(color, variant)}
        </span>
        <span>{text}</span>
      </div>
      {cta && cta}
      {onClick && (
        <div className={styles.buttonHolder}>
          <ButtonBase onClick={(e) => handleClick(e)} aria-label="Close Info Bar">
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
              <path d="M326.6 166.6L349.3 144 304 98.7l-22.6 22.6L192 210.7l-89.4-89.4L80 98.7 34.7 144l22.6 22.6L146.7 256 57.4 345.4 34.7 368 80 413.3l22.6-22.6L192 301.3l89.4 89.4L304 413.3 349.3 368l-22.6-22.6L237.3 256l89.4-89.4z" />
            </svg>
          </ButtonBase>
        </div>
      )}
    </div>
  )
}

export default InfoBar
